import { memo } from 'react';
import { Skeleton, Table } from '@mantine/core';

interface TableLoadingSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableLoadingSkeleton = memo<TableLoadingSkeletonProps>(
  ({ rows = 5, columns = 4 }) => {
    return (
      <Table>
        <Table.Thead>
          <Table.Tr>
            {Array.from({ length: columns }).map((_, index) => (
              <Table.Th key={index}>
                <Skeleton height={20} width='80%' />
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <Table.Tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <Table.Td key={colIndex}>
                  <Skeleton
                    height={16}
                    width={colIndex === 0 ? '90%' : '70%'}
                  />
                </Table.Td>
              ))}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    );
  }
);

TableLoadingSkeleton.displayName = 'TableLoadingSkeleton';
